import React, { useEffect, useState } from 'react';
import { exportToExcel } from 'src/utils/Common';
import { BottomNavigationAction, Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';

function EmployeeExcelExport(JsonData) {
  const [employeeRoleData, setEmployeeRoleData] = useState([]);
  const GetEmployeeRole = () => {
    axios
      .get(`/GetEmployeeRole`)
      .then(response => {
        if (response.data.length > 0) {
          setEmployeeRoleData(response.data);
        }
      })
      .catch(error => { });
  };
  
  const { t } = useTranslation('Technician_Management');
  useEffect(() => {
    GetEmployeeRole();
  }, []);

  
  if (JsonData?.JsonData?.length === 0){
    return (
      <BottomNavigationAction 
      disabled={true}
      showLabel label={t('lblExport')} icon={<CloudDownloadIcon />} />
    )
  }


  var ExportData = JsonData.JsonData.map(item => {
    return {
      ServiceShopId: item.ServiceShopId,
      employeeRoleData:employeeRoleData.filter(i => i.Id === item.RoleId)[0]?.Dsc,
      Active:item.Active == 1 ? 'Active' : 'Passive',
      UserType:item.UserTypes,
      TechnicianCode:item.TechnicianCode,
      Description:item.Description,
      UserName:item.UserName,
      Dsc:item.Dsc,
      Email:item.Email,
      Phone: item.Phones,
      Address: item.Address
    }
  });

  return (
    // <ExcelFile element={ 
    //   <BottomNavigationAction showLabel label={t('lblExport')} icon={<CloudDownloadIcon />} />}>
    //   <ExcelSheet data={ExportData} name="EmployeesList">
    //   <ExcelColumn label={t('lblServiceShop')}value="ServiceShopId" />
    //   <ExcelColumn label={t('lblUserType')} value="UserType" />
    //   <ExcelColumn label={t('lblRole')} value="employeeRoleData" />
    //   <ExcelColumn label={t('lblDescription')} value="Description" />
    //   <ExcelColumn label={t('lblEmployeeCode')} value="TechnicianCode" />
    //   <ExcelColumn label={t('lblSicilNo')} value="UserName" />
    //   <ExcelColumn label={t('lblEmployee')}  value="Dsc" />
    //   <ExcelColumn label={t('lblActive')}  value="Active" />
    //   <ExcelColumn label={t('lblMail')} value="Email" />
    //   <ExcelColumn label={t('lblPhone')} value="Phone" />
    //   <ExcelColumn label={t('lblEmployeeAdress')} value="Address" />    
    //   </ExcelSheet>

    // </ExcelFile>
    <>
      <Button
        size="small"
       variant="contained"
         color="primary"
         fullWidth
         endIcon={<CloudDownloadIcon />}
         onClick={() => exportToExcel(ExportData, 'EmployeeExport') }
       >
        {t('lblExport')}
       </Button>
    </>
  );
}

EmployeeExcelExport.propTypes = {

};

export default EmployeeExcelExport;
